import { SideMenuDropdown } from '@barracuda-internal/bds-core-v2';
import { DateTime } from 'luxon';
import { DetectionFields } from 'src/types/reportingTypes';

export const scanlogsSearchFields = [
	'file',
	'owner',
	'policy',
	'action',
	'creator',
];

export type ColumnKey =
	| 'decision'
	| 'file'
	| 'platforms'
	| 'filePath'
	| 'scanDate'
	| 'ownerNames'
	| 'states'
	| 'policies'
	| 'actions';

export const COLUMN_DEFINITIONS: { accessorKey: ColumnKey; header: string }[] =
	[
		{ accessorKey: 'decision', header: 'Decision' },
		{ accessorKey: 'file', header: 'File' },
		{ accessorKey: 'platforms', header: 'Cloud Type' },
		{ accessorKey: 'filePath', header: 'File Path' },
		{ accessorKey: 'scanDate', header: 'Scanned' },
		{ accessorKey: 'ownerNames', header: 'Owner/Creator' },
		{ accessorKey: 'states', header: 'Status' },
		{ accessorKey: 'policies', header: 'Policies Invoked' },
		{ accessorKey: 'actions', header: 'Action Taken' },
	];

export const DATE_SHORTCUTS = [
	{
		label: 'Last day',
		getValue: (): [DateTime, DateTime] => {
			const now = DateTime.local();
			return [now.minus({ days: 1 }).startOf('day'), now];
		},
	},
	{
		label: 'Last 3 days',
		getValue: (): [DateTime, DateTime] => {
			const now = DateTime.local();
			return [now.minus({ days: 3 }).startOf('day'), now];
		},
	},
	{
		label: 'Last 7 days',
		getValue: (): [DateTime, DateTime] => {
			const now = DateTime.local();
			return [now.minus({ days: 7 }).startOf('day'), now];
		},
	},
	{
		label: 'Last 30 days',
		getValue: (): [DateTime, DateTime] => {
			const now = DateTime.local();
			return [now.minus({ days: 30 }).startOf('day'), now];
		},
	},

	{
		label: 'Last 90 days',
		getValue: (): [DateTime, DateTime] => {
			const now = DateTime.local();
			return [now.minus({ days: 90 }).startOf('day'), now];
		},
	},
];

export const dropdowns: SideMenuDropdown[] = [
	{
		label: 'Columns',
		items: [
			{ id: 'platforms', label: 'Cloud Type' },
			{ id: 'filePath', label: 'File Path' },
			{ id: 'ownerNames', label: 'Owner/Creator' },
			{ id: 'states', label: 'Status' },
			{ id: 'policies', label: 'Policies Invoked' },
			{ id: 'actions', label: 'Action Taken' },
		],
	},
];

export type ColumnVisibilityState = {
	[key in Exclude<ColumnKey, 'file' | 'decision' | 'scanDate'>]: boolean;
};

export const COLUMN_VISIBILITY_INITIAL_STATE: ColumnVisibilityState = {
	platforms: true,
	filePath: true,
	ownerNames: true,
	states: true,
	policies: true,
	actions: true,
};

export const COLUMNS_WITHOUT_SORTING: ColumnKey[] = [
	'decision',
	'platforms',
	'ownerNames',
	'states',
	'policies',
	'actions',
	'filePath',
];

export const COLUMNS_WITHOUT_FILTERING: ColumnKey[] = [
	'scanDate',
	'ownerNames',
	'policies',
	'actions',
	'filePath',
	'file',
];

export const SCANLOGS_COLUMN_POSSIBLE_VALUES: DetectionFields = {
	decision: {
		name: 'Decision',
		type: 'keyword',
		possibleValues: {
			Violation: 'Violation',
			Clean: 'Clean',
		},
	},
	states: {
		name: 'Status',
		type: 'keyword',
		possibleValues: {
			Finished: 'Finished',
			Canceled: 'Canceled',
			Deleted: 'Deleted',
			Quarantined: 'Quarantined',
		},
	},
	platforms: {
		name: 'Platform',
		type: 'keyword',
		possibleValues: {
			OneDriveConnector: 'OneDriveConnector',
			SharepointLibraryConnector: 'SharepointLibraryConnector',
		},
	},
};
